// extracted by mini-css-extract-plugin
module.exports = {"overlay":"dialog_overlay__Z6qRN","content":"dialog_content__8b6ar","xs":"dialog_xs__aG05r","sm":"dialog_sm__PeW_c","md":"dialog_md__3cZUe","lg":"dialog_lg__hvKP2"};